const ss_quizTagPrefix = "Quiz_";

//MG: Function to dynamically update total step count in the quiz
function updateQuizTotalStepsBySection() {
  document.addEventListener("DOMContentLoaded", function () {
    const quizSections = document.querySelectorAll("div section[data-quiz-question-group]");
    const TotalSteps = quizSections.length;
    const quizTotalStepsElements = document.querySelectorAll(".quiz-total-steps");
    quizTotalStepsElements.forEach(function (quizTotalStep) {
      quizTotalStep.innerHTML = TotalSteps.toString().padStart(2, "0");
    });
  });
}

//MG: Function to show next/hide current section based on an answer being selected
function showHideSectionsWhenSelectionMade() {
  document.addEventListener("DOMContentLoaded", function () {
    const quizSections = document.querySelectorAll("div section[data-quiz-question-group]");
    quizSections.forEach(function (quizSection, index) {
      if (index > 0) {
        quizSection.closest("div").style.display = "none";
      }
    });

    quizSections.forEach(function (quizSection) {
      const quizAnswers = quizSection.querySelectorAll("[data-answer-reference]");
      quizAnswers.forEach(function (quizAnswer) {
        quizAnswer.addEventListener("click", function () {
          const currentSection = this.closest("section[data-quiz-question-group]");
          const currentDiv = currentSection.closest("div");
          const nextDiv = currentDiv.nextElementSibling;

          if (nextDiv && nextDiv.querySelector("section[data-quiz-question-group]")) {
            currentDiv.style.display = "none";
            nextDiv.style.display = "block";
          }
        });
      });
    });
  });
}

function answerCardsScroll(sectionEl) {
	sectionEl.querySelector('.previous-card-button').addEventListener('click', function() {
		const answersContainer = sectionEl.querySelector('.quiz-step__image-cards__answers');
		const cardWidth = sectionEl.querySelector('.quiz-step__image-cards__answer').offsetWidth;
		answersContainer.scrollBy({
			left: -cardWidth,
			behavior: 'smooth'
		});
	});

	sectionEl.querySelector('.next-card-button').addEventListener('click', function() {
		const answersContainer = sectionEl.querySelector('.quiz-step__image-cards__answers');
		const cardWidth = sectionEl.querySelector('.quiz-step__image-cards__answer').offsetWidth;
		answersContainer.scrollBy({
			left: cardWidth,
			behavior: 'smooth'
		});
	});

  sectionEl.querySelectorAll('.quiz-step__image-cards__answer img').forEach(function(image) {
    image.addEventListener('click', function() {
      sectionEl.querySelectorAll('.quiz-step__image-cards__answer img').forEach(function(img) {
        img.classList.remove('selected');
        if (img.classList.length === 0) {
          img.removeAttribute('class');
        }
      });
      this.classList.add('selected');
    });
  });
}

//MG: Back button functionality to go back to the previous section which will hide the
//    current section and show the previous one
function backButtonFunctionality() {
  const backButtons = document.querySelectorAll(
    '[data-back-link-to="previous"]'
  );
  backButtons.forEach(function (backButton) {
    backButton.addEventListener("click", function () {
      const currentDiv = this.closest("div.quiz-step-section");
      const previousDiv = currentDiv.previousElementSibling;

      if (previousDiv && previousDiv.querySelector("section[data-quiz-question-group]")) {
        currentDiv.style.display = "none";
        previousDiv.style.display = "block";
      }
    });
  });
}

//MG: Function to record the quiz answers to ultimately result in a quiz result tag
async function recordQuizAnswers() {
  const quizResults = [];
  const quizAnswers = document.querySelectorAll("[data-answer-reference]");
  const allLiDataCategoryItems = document.querySelectorAll("li[data-category]");
  const allDataCategoryItems = Array.from(allLiDataCategoryItems).map(function (item) {
    const dataCategory = item.getAttribute("data-category");
    const dataAnswer = item.getAttribute("data-answer");
    return { dataCategory, dataAnswer };
  });

  quizAnswers.forEach(function (quizAnswer) {
    quizAnswer.addEventListener("click", function () {
      const answerValue = this.getAttribute("data-answer-reference");
      const section = this.closest("section[data-quiz-question-group]").getAttribute("data-step-number");
      const isLastQuestion = this.closest("section[data-quiz-question-group]").getAttribute("data-is-last-question");
      const existingAnswerIndex = quizResults.findIndex((result) => result.section === section);

      if (existingAnswerIndex !== -1) {
        quizResults[existingAnswerIndex].answer = answerValue;
      } else {
        quizResults.push({ section, answer: answerValue });
      }

      if (isLastQuestion === "true") {quizResultsAnswers = quizResults.map((result) => result.answer).join(" ");
        const quizResultsCategory = allDataCategoryItems.find(
          (item) => item.dataAnswer === quizResultsAnswers
        );
        if (quizResultsCategory) {
          processQuizCategory(quizResultsCategory);
        }
      }
    });
  });
}

async function processQuizCategory(quizResultsCategory) {
  // add the customer tag to the inpout on the form
  // add the return url to the hidden input on the form
  const customerSignupForm = document.querySelector('[data-quiz-customer-signup-form]');
  if (customerSignupForm) {
    const customerTagInput = customerSignupForm.querySelector('[data-customer-form-quiz-category-tag]');
    const returnToUrlInputEl = customerSignupForm.querySelector('[data-return-to-url]');
    if (customerTagInput) {
      customerTagInput.value = `${customerTagInput.value}, ${addDeviceToCustomerTag(customerTagInput.value)}, ${ss_quizTagPrefix}${quizResultsCategory.dataCategory}`;
      returnToUrlInputEl.value = `${returnToUrlInputEl.value}?category=${quizResultsCategory.dataCategory}`;
    }
  }
  else {
    //redirect to the results page with the category in the URL
    // if the customer signup form is not present, we assume we are on the results page
    const quizResultsRedirectEl = document.querySelector('[data-redirect-url]');
    if (quizResultsRedirectEl) {
      const customerEmail = quizResultsRedirectEl.dataset.customerEmail;
      const customerTag = quizResultsCategory.dataCategory;
      if (customerEmail && customerTag) {
        const submitResult = await submitEmailAndTagToBackend(customerEmail, customerTag);
      }
      // Redirect to the results page with the category in the URL
      const returnToUrl = `${quizResultsRedirectEl.href}?category=${customerTag}`;
      window.location.href = returnToUrl;
    }
  }
}

// MG: Function to take the result of the quiz and transfer it to the results page
// Uses the default customer signup form to capture the quiz tag
// interrupts the form submission to call the BE app (which removed other tags and adds the quiz tag)
// then submits the form to the results page
function transferQuizTagToResultsPage() {
  const customerSignupForm = document.querySelector('[data-quiz-customer-signup-form]');
  if(!customerSignupForm) return;

  const submitButton = customerSignupForm.querySelector('[data-quiz-customer-signup-form-submit]');
  if (!submitButton) return;
  
  const customerTagsCategoryInputEl = customerSignupForm.querySelector('[data-customer-form-quiz-category-tag]');
  submitButton.addEventListener('click', async function (event) {
    event.preventDefault();
    if(customerSignupForm.checkValidity()) {
      const formData = new FormData(customerSignupForm);
      const customerEmailAddress = formData.get('contact[email]');
      const customerQuizTag = customerTagsCategoryInputEl ? customerTagsCategoryInputEl.value : null;
      const customerQuizTagHandle = getCategoryHandleFromInputValue(customerQuizTag);
      if(customerQuizTagHandle && customerEmailAddress) {
        const submitResult = await submitEmailAndTagToBackend(customerEmailAddress, customerQuizTagHandle);
        if (submitResult === false) {
          console.error("Failed to submit email and tag to backend.");
        }
        customerSignupForm.submit();
      }
    }
  });
}

//MG: Function to determine which category to show on the results page based on the URL
function workOutWhichCategoryToShow() {
  document.addEventListener("DOMContentLoaded", async function () {
    const url = window.location.href;
    const category = new URL(url).searchParams.get("category");
    const quizResults = document.querySelectorAll(".quiz-results");
    if (category) {
      quizResults.forEach((quizResult) => {
        quizResult.setAttribute("data-page-category", category);
        if (quizResult.dataset.handle === category) {
          quizResult.classList.add("show-this-category");
          quizResult.style.display = "flex";
        }
      });
    }
  });
}

//MG: Function to handle the Read More link on the Quiz Results page
function quizResultsReadMore() {
  const readMoreAnchor = document.querySelectorAll(".quiz-results__main-result-summary .read-more");
  const scrollOffset = 100;
  readMoreAnchor.forEach(function (anchor) {
    anchor.addEventListener("click", function (event) {
      event.preventDefault();
      const quizResultsDetailsSummary = anchor.closest(".quiz-results__main-result-summary").nextElementSibling;
      if (quizResultsDetailsSummary) {
        quizResultsDetailsSummary.style.display = "block";
        const anchorRect = anchor.getBoundingClientRect();
        const absoluteY = window.scrollY + anchorRect.top - scrollOffset;
        window.scrollTo({ top: absoluteY, behavior: "smooth" });
        anchor.style.display = "none";
      }
    });
  });
}

//MG: Function to handle the carousel of people you may know
function peopleYouMayKnowCarousel() {
  document.addEventListener("DOMContentLoaded", function () {
    const totalPeople = document.querySelectorAll(".show-this-category .person").length;

    if (totalPeople) {
      document.querySelector(".show-this-category .similar-people__next-card-button").addEventListener("click", function () {
        const people = document.querySelectorAll(".show-this-category .person");
        people.forEach((person) => {
          let currentOrder = parseInt(person.getAttribute("data-order"));
          if (currentOrder === 1) {
            person.setAttribute("data-order", totalPeople);
          } else {
            person.setAttribute("data-order", currentOrder - 1);
          }
        });

        people.forEach((person) => {
          let currentOrder = parseInt(person.getAttribute("data-order"));
          if (currentOrder === 3) {
            person.classList.add("person-in-focus");
          } else {
            person.classList.remove("person-in-focus");
          }
        });
      });

      document.querySelector(".show-this-category .similar-people__previous-card-button").addEventListener("click", function () {
        const people = document.querySelectorAll(".person");
        people.forEach((person) => {
          let currentOrder = parseInt(person.getAttribute("data-order"));
          if (currentOrder === totalPeople) {
            person.setAttribute("data-order", 1);
          } else {
            person.setAttribute("data-order", currentOrder + 1);
          }
        });

        people.forEach((person) => {
          let currentOrder = parseInt(person.getAttribute("data-order"));
          if (currentOrder === 3) {
            person.classList.add("person-in-focus");
          } else {
            person.classList.remove("person-in-focus");
          }
        });
      });
    }
  });
}

//MG: Function to copy the quiz page results URL to the clipboard from the share via link icon
function copyQuizPageURL() {
  const url = window.location.href;
  navigator.clipboard.writeText(url).then(() => {
    const popover = document.querySelector(".show-this-category .popover");
    popover.classList.add("show");
    setTimeout(() => {
      popover.classList.remove("show");
    }, 2000);
  })
  .catch((err) => {
    console.error("Failed to copy: ", err);
  });
}

//MG: Function to construct social sharing URLs for various platforms
function constructSocialSharingUrls() {
  const facebookShareButton = document.querySelectorAll(".facebook-quiz-share-button");
  const instagramShareButton = document.querySelectorAll(".instagram-quiz-share-button");
  const linkedinShareButton = document.querySelectorAll(".linkedin-quiz-share-button");
  const pinterestShareButton = document.querySelectorAll(".pinterest-quiz-share-button");
  const tiktokShareButton = document.querySelectorAll(".tiktok-quiz-share-button");
  const twitterShareButton = document.querySelectorAll(".twitter-quiz-share-button");
  const youtubeShareButton = document.querySelectorAll(".youtube-quiz-share-button");

  const resultsPageUrl = window.location.href;

  // update the href attributes of the share buttons if the buttons exist
  if (facebookShareButton.length > 0) {
    facebookShareButton.forEach((button) => 
      button.setAttribute("href", `https://www.facebook.com/sharer/sharer.php?u=${(resultsPageUrl)}`));
  }
  if (instagramShareButton.length > 0) {
    instagramShareButton.forEach((button) =>
      button.setAttribute("href", `https://www.instagram.com/share?url=${(resultsPageUrl)}`)
    );
  }
  if (linkedinShareButton.length > 0) {
    linkedinShareButton.forEach((button) =>
      button.setAttribute("href", `https://www.linkedin.com/shareArticle?mini=true&url=${(resultsPageUrl)}`)
    );
  }
  if (pinterestShareButton.length > 0) {
    pinterestShareButton.forEach((button) =>
      button.setAttribute("href", `https://pinterest.com/pin/create/button/?url=${(resultsPageUrl)}`)
    );
  }
  if (tiktokShareButton.length > 0) {
    tiktokShareButton.forEach((button) =>
      button.setAttribute("href", `https://www.tiktok.com/share?url=${(resultsPageUrl)}`)
    );
  }
  if (twitterShareButton.length > 0) {
    twitterShareButton.forEach((button) =>
      button.setAttribute("href", `https://twitter.com/intent/tweet?url=${(resultsPageUrl)}`)
    );
  }
  if (youtubeShareButton.length > 0) {
    youtubeShareButton.forEach((button) =>
      button.setAttribute("href", `https://www.youtube.com/share?url=${(resultsPageUrl)}`)
    );
  }
}
function getCategoryHandleFromInputValue(inputValue) {
  if (!inputValue) return null;

  const tags = inputValue.split(',').map(tag => tag.trim());
  const categoryTag = tags.find(tag => tag.startsWith(ss_quizTagPrefix));
  
  return categoryTag ? categoryTag.replace(ss_quizTagPrefix, '') : null;
}

// function to check if the user is on a mobile device (users with touch screens)
function isMobileDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

function addDeviceToCustomerTag(customerTag) {
  if (isMobileDevice()) {
    return `${customerTag} -- Mobile`;
  } else {
    return `${customerTag} -- Desktop`;
  }
}

async function submitEmailAndTagToBackend(email, tag) {
  const raw = JSON.stringify({
    "email": email,
    "tag": tag
  });

  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: raw,
  };

  try {
    const response = await fetch("/a/quiz/customer/tags", requestOptions);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const result = await response.text();
    return result;
  } catch (error) {
    console.error("Error updating tag:", error);
    return false;
  }
}

updateQuizTotalStepsBySection();
showHideSectionsWhenSelectionMade();
backButtonFunctionality();
recordQuizAnswers();
transferQuizTagToResultsPage();
workOutWhichCategoryToShow();
quizResultsReadMore();
peopleYouMayKnowCarousel();
constructSocialSharingUrls();